import { ref, onMounted, onBeforeUnmount } from 'vue';
import fitty from 'fitty';

export function useFitty(options) {
  const el = ref(null);
  let instance = null;

  onMounted(() => {
    if (el.value) {
      el.value.style.fontSize = `${options.maxSize}px`;
    }
    document.fonts.ready.then(() => {
      if (el.value) {
        instance = fitty(el.value, options);
      }
    });
  });

  onBeforeUnmount(() => {
    instance?.unsubscribe();
  });

  return el;
}
